// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'globalthis/auto' // 兼容全局变量
import Vue from "vue";
import App from "./App";
import router from "./router";
import api from "./js/API";
import axios from "axios";
import store from "./store";
import unicomponent from "./js/utils/uiComponent";
// import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import infiniteScroll from "vue-infinite-scroll";
import "./assets/style/oldIconfont/iconfont.css";
import "./assets/style/oldIconfont/iconfont.js";
import "./assets/style/iconfont/iconfont.css";
import "./assets/style/iconfont/iconfont.js";
import { initFingerPrint } from "@/js/utils/initFingerPrint.js";
import { uploadBussinessLog } from "./js/utils/bussinessLog";
initFingerPrint();
//分享页面
import VueClipboard from "vue-clipboard2";
import VueLazyload from 'vue-lazyload'
import { platform, share } from "yach.open.jssdk";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/style/common.css";
import "@/assets/style/resetElement.css";
import EventBus from './js/EventBus'
// import VConsole from "vconsole";
unicomponent();

// console.log(api)
if(process.env.env_config!=='production'){
  // const vConsole = new VConsole();
}
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.use(VueLazyload,  {
  lazyComponent: true
});
Vue.config.productionTip = false;
Vue.http = Vue.prototype.$http = axios;
Vue.api = Vue.prototype.$api = api;
Vue.bussinessLog = Vue.prototype._bussinessLog = uploadBussinessLog;
Vue.prototype.yach = { platform, share };
Vue.prototype.$bus =EventBus
// Vue.component("DynamicScroller", DynamicScroller);
// Vue.component("DynamicScrollerItem", DynamicScrollerItem);
Vue.use(infiniteScroll);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js